<template>
  <div :style="{ 'border-bottom': `1px solid #E0E0E0` }">
    <v-simple-table fixed-header>
      <template v-slot:default>
        <tbody>
          <tr :style="appropriateStyleTr">
            <td :style="appropriateStyleTd">{{ title }}</td>
            <td v-if="category" :style="appropriateStyleTd"><v-select :items="printers" v-model="printers[0]" item-text="name" item-value="id"></v-select></td>
            <td v-if="comment" :style="appropriateStyleTd"><v-select :items="commentGroups" v-model="commentGroups[0]" item-text="name" item-value="id"></v-select></td>

            <td :class="{'text-right': !category && !comment, 'justify-end': category || comment}" :style="appropriateStyleTd">
              <ButtonActionEdit v-if="editable" @click="$emit('edit')" />
              <ButtonActionDelete v-if="deleteable" @click="$emit('delete')" />
              <ButtonActionDrag v-if="draggable" @click="$emit('drag')" />
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ButtonActionEdit from './ButtonActionEdit'
import ButtonActionDelete from './ButtonActionDelete'
import ButtonActionDrag from './ButtonActionDrag'

export default {
  components: {
    ButtonActionEdit,
    ButtonActionDelete,
    ButtonActionDrag
  },
  data () {
    this.localPrinters = []
  },
  props: {
    editable: {
      default: true,
      type: Boolean
    },
    deleteable: {
      default: true,
      type: Boolean
    },
    title: {
      required: true,
      type: String
    },
    draggable: {
      default: false,
      type: Boolean
    },
    category: {
      required: false,
      default: null,
      type: Object
    },
    comment: {
      required: false,
      default: null,
      type: Object
    }
  },
  computed: {
    printers () {
      if (!this.category.id) return
      const printerLocations = this.$store.state.printerslocations.groupPrinters[this.category.id]
      return printerLocations && printerLocations.length ? printerLocations : [{ 'name': 'Nima lokacije', 'id': null }]
    },
    commentGroups () {
      if (!this.comment) return
      const commentGroups = this.$store.state.businessUnits.komentarjiSkupine[this.comment.id]
      return commentGroups && commentGroups.length ? commentGroups : [{ 'name': 'Nima lokacije', 'id': null }]
    },
    appropriateStyleTr () {
      return this.category || this.comment ? "display: flex;justify-content: space-between;align-items: center;" : "" // eslint-disable-line
    },
    appropriateStyleTd () {
      return this.category  || this.comment ? "display: flex;align-items: center; flex: 1;" : "" // eslint-disable-line
    }
  },
  methods: {
    ...mapActions('businessUnits', ['getCommentCategories']),
    ...mapActions('printerslocations', ['getCategoryLocationPrinters'])
  },
  async created () {
    if (!this.category && !this.comment) return
    if (this.category) {
      await this.getCategoryLocationPrinters({ category: this.category })
    }
    if (this.comment) {
      await this.getCommentCategories({ id: this.comment.id })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__wrapper {
  display: contents !important;
}
</style>
